import { render } from "./ListSecciones.vue?vue&type=template&id=f5aab3e0"
import script from "./ListSecciones.vue?vue&type=script&lang=js"
export * from "./ListSecciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__